import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModuleWeb } from '../material/material.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { WebBuilderHomeComponent } from './web-builder-home.component';
import { WebScreenModule } from '../web-screen/web-screen.module';
import { WebSidenavModule } from '../sidenav/web-sidenav.module';
import { WebSidenavContentModule } from '../sidenav-content/web-sidenav-content.module';
import { SidenavContentListModule } from '../sidenav-content-list/web-sidenav-content-list.module';
import { RouterModule, Routes } from '@angular/router';
import { CdkDrag, DragDropModule } from '@angular/cdk/drag-drop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { GridsterModule,GridsterPrototypeService } from '@hyperviewhq/angular2gridster';
import { ApiconfigModule } from 'shared-library';
import { webPublishAppModule } from '../publish-app/publish-app.module';

const routes: Routes = [
  {path:'' , component: WebBuilderHomeComponent},
];

@NgModule({
  declarations: [WebBuilderHomeComponent],
  imports: [
    CommonModule,
    MaterialModuleWeb,
    ToolbarModule,
    WebScreenModule,
    WebSidenavModule,
    webPublishAppModule,
    WebSidenavContentModule,
    SidenavContentListModule,
    RouterModule.forChild(routes),
    MaterialModuleWeb,
    DragDropModule,
    CdkDrag,
    GridsterModule.forRoot(),
    MatTooltipModule,
    MatIconModule,
    ApiconfigModule
  ],
  exports: [WebBuilderHomeComponent],
  providers:[GridsterPrototypeService]
})
export class WebBuilderHomeModule { }
